/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AntennaA
 */
export interface AntennaA {
    /**
     * 
     * @type {string}
     * @memberof AntennaA
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof AntennaA
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof AntennaA
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof AntennaA
     */
    eloshieldConfigurationId: string;
    /**
     * Antenna CAN index in configuration. This is configured with the DIP switch on the PCB.
     * @type {number}
     * @memberof AntennaA
     */
    antennaIndex: number;
    /**
     * The network IDs of A antennas start at 10000. The maximum value is 65533.
     * @type {number}
     * @memberof AntennaA
     */
    networkId: number;
    /**
     * Height in decimeter.
     * @type {number}
     * @memberof AntennaA
     */
    heightDm: number;
    /**
     * 
     * @type {number}
     * @memberof AntennaA
     */
    zone1RadiusCm: number;
    /**
     * 
     * @type {number}
     * @memberof AntennaA
     */
    zone2RadiusCm: number;
    /**
     * 
     * @type {number}
     * @memberof AntennaA
     */
    mutingDistanceCm: number;
}

/**
 * Check if a given object implements the AntennaA interface.
 */
export function instanceOfAntennaA(value: object): value is AntennaA {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('eloshieldConfigurationId' in value) || value['eloshieldConfigurationId'] === undefined) return false;
    if (!('antennaIndex' in value) || value['antennaIndex'] === undefined) return false;
    if (!('networkId' in value) || value['networkId'] === undefined) return false;
    if (!('heightDm' in value) || value['heightDm'] === undefined) return false;
    if (!('zone1RadiusCm' in value) || value['zone1RadiusCm'] === undefined) return false;
    if (!('zone2RadiusCm' in value) || value['zone2RadiusCm'] === undefined) return false;
    if (!('mutingDistanceCm' in value) || value['mutingDistanceCm'] === undefined) return false;
    return true;
}

export function AntennaAFromJSON(json: any): AntennaA {
    return AntennaAFromJSONTyped(json, false);
}

export function AntennaAFromJSONTyped(json: any, ignoreDiscriminator: boolean): AntennaA {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'eloshieldConfigurationId': json['eloshieldConfigurationId'],
        'antennaIndex': json['antennaIndex'],
        'networkId': json['networkId'],
        'heightDm': json['heightDm'],
        'zone1RadiusCm': json['zone1RadiusCm'],
        'zone2RadiusCm': json['zone2RadiusCm'],
        'mutingDistanceCm': json['mutingDistanceCm'],
    };
}

export function AntennaAToJSON(json: any): AntennaA {
    return AntennaAToJSONTyped(json, false);
}

export function AntennaAToJSONTyped(value?: AntennaA | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'eloshieldConfigurationId': value['eloshieldConfigurationId'],
        'antennaIndex': value['antennaIndex'],
        'networkId': value['networkId'],
        'heightDm': value['heightDm'],
        'zone1RadiusCm': value['zone1RadiusCm'],
        'zone2RadiusCm': value['zone2RadiusCm'],
        'mutingDistanceCm': value['mutingDistanceCm'],
    };
}

